export const messages = {
  authentication_error: 'Autentikációs probléma, újra be kell jelentkeznie.',
  invalid_login: 'Érvénytelen felhasználónév vagy jelszó.',
  server_error: 'Hiba történt. Próbálja meg később.',
  invalid_qr_code: 'Érvénytelen QR kód. Válasszon egy másikat.',
  required_fields_error: 'Néhány kötelező mező hiányzik, nézze át az űrlapot.',
  field_types_error:
    'A mezők típusa nem megfelelő, vizsgálja meg, hogy számok helyett nem betűt írt bizonyos mezőkbe.',
  ok: 'Sikeres mentés, az űrlap sorszáma: ',
  datetime_not_valid_format: 'A formátum éééé-hh-nn óó:pp.',
  field_is_required: 'Ennek a mezőnek a kitöltése kötelező.',
  problems_field_is_required: 'A probléma kód mezőnek a kitöltése kötelező.',
  end_report_time_is_earlier:
    'A hívás hossza nem lehet kevesebb mint 1 perc. Javítsa az időpontokat.',
  time_is_in_future:
    'Érvénytelen időpont. Korábbinak kell lennie a jelen pillanatnál.',
  title_new_form_create: 'Hívás rögzítése',
  title_existing_form_update: 'Hívás szerkesztése',
  submission_new_call: 'HÍVÁS BEFEJEZÉSE ÉS ADATOK ELKÜLDÉSE',
  submission_existing_call: 'SZERKESZTÉS BEFEJEZÉSE ÉS ADATOK ELKÜLDÉSE',
  missing_fields: 'Hiányzó mezők: ',
  callFrequency: 'Hívás gyakorisága',
  expectations: 'Hívó elvárásai',
  sex: 'Hívó neme',
  age: 'Hívó kora',
  therapies: 'Terápiás alapelemek',
  callerSatisfied: 'Hivó Elégedett',
  helperSatisfied: 'Segítő elégedett',
  relationLevel: 'Kapcsolat',
  inadequateCallType: '',
  max_number_of_selectable_problems: 'Legfeljebb 5 problémakód választható!',
}
